const apiConstants = {
    "addScenarioOnTheFly": "/add_scenario_on_the_fly",
    "adminManagement": {
        "addUser": "/add-user",
        "baseUrl": "/manage",
        "deleteUser": "/delete-user/:userId",
        "tenants": {
            "all": "?only_tenants=:only_tenants",
            "baseUrl": "/tenants"
        },
        "users": {
            "all": "?only_users=:only_users",
            "baseUrl": "/users"
        }
    },
    "allStorageLocations": "/storage-locations",
    "baseUrl": "",
    "binWidth": "/bin_width",
    "bom": "/sku-bom",
    "charts": {
        "actualConsumption": "/actual-consumption",
        "baseUrl": "/charts",
        "calculationStatus": "/calc-mode",
        "clientTargetVsSafetyStock": "/client-target-vs-safety-stock",
        "costPerUnit": "/cost-perunit",
        "dohBenchmarking": "/doh-benchmarking",
        "dohInventoryBalanced": "/doh-inventory-balanced",
        "histogram": {
            "baseUrl": "/histograms/:name",
            "download": "/download"
        },
        "historicalInventory": "/historical-inventory?unit_of_measurement=:unit_of_measurement",
        "inventoryBreakdownByCategory": "/inventory-breakdown-by-category",
        "inventoryBreakdownDiagnostics": "/inventory-diagnostics-summary",
        "inventoryCoverageDevelopment": "/inventory-coverage-development",
        "inventoryProjection": "/inventory-projection",
        "obsoleteWaterfall": "/obsolete-waterfall",
        "onHandVsRiskPeriodMatrix":
            "/on_hand-vs-risk_period-matrix?col_x=:col_x&col_y=:col_y&inventory_type=:inventory_type",
        "overviewWaterfall": "/overview-waterfall?inventory_type=:inventoryType",
        "poPlacementWaterfall": "/po-placement-vs-leadtime",
        "rapidDiagnostics": {
            "AvgInventoryVsClientAvgTarget": "/avg-inventory-vs-client-avg-target",
            "CurrentInventoryVsClientMinMaxTarget": "/current-inventory-vs-client-min-max-target",
            "baseUrl": "/rapid-diagnostics-waterfall"
        },
        "rapidDiagnosticsSummary": "/rapid-diagnostics-summary",
        "replenishmentStrategy": "/replenishment-strategy",
        "safetystockModel": "/safetystock-model",
        "serviceLevelMatrix": "/service-level-matrix?col_x=:col_x&col_y=:col_y",
        "skuMovie": "/sku-movie",
        "targetByCategory": "/target-category",
        "targetStockBreakdown": "/target-stock-breakdown",
        "waterfallImprovement": "/improvement-waterfall"
    },
    "chat": {
        "baseUrl": "/chat",
        "delete": "",
        "feedback": "/feedback",
        "get": "?limit=:limit&offset=:offset"
    },
    "config": "/config",
    "configuration": "/configuration",
    "cycle": {
        "active": "?active=true",
        "baseUrl": "/cycle",
        "details": "/:id"
    },
    "deadStockDetails": "/dead-stock",
    "exportChatFeedback": "/export-chat-feedback",
    "files": {
        "baseUrl": "/files",
        "move": "/move",
        "preSignedUrl": "/pre-signed-url",
        "upload": "/upload"
    },
    "inventoryHealth": {
        "baseUrl": "/inventory-health",
        "largestGaps": "/top?inventory_type=:inventoryType",
        "top": "/top"
    },
    "inventoryTargetAdherence": "/inventory-target-adherence",
    "issues": {
        "baseUrl": "/issues",
        "download": "/download",
        "summary": "/summary"
    },
    "jobs": {
        "baseUrl": "/jobs",
        "details": "/:id",
        "latest": "/latest",
        "statistics": "/statistics/summary",
        "statusLogs": "/status-logs"
    },
    "leadTimeDerivations": "/lead-time-deviations",
    "locationsData": "location-data",
    "note": {
        "addNote": "/sku/:skuId/location/:locationId/notes",
        "baseUrl": "",
        "deleteNote": "/notes/:noteId",
        "getAllNotes": "/notes",
        "getNote": "/sku/:skuId/location/:locationId/notes",
        "updateNote": "/notes/:noteId"
    },
    "overrides": {
        "baseUrl": "/overrides",
        "download": "/download",
        "upload": "/upload"
    },
    "pivotEnums": "/pivot-enums",
    "poData": "/po-data",
    "poHealthStatus": "/po-health-status",
    "poReview": "/po-health-donut",
    "poReviewStatus": "/po-review",
    "questionnaire": {
        "assessmentsList": "/assessments",
        "assignOrUnAssignUser": "/assessments/:assessmentGroupId",
        "baseUrl": "/questionnaire",
        "currentAssessment": "/current-assessment",
        "currentAssessmentForSuperAdmin": "/assessment-users-group/:assessmentGroupId",
        "deleteAssessment": "/assessments/:assessmentGroupId",
        "detailedResults": "/detailed-results?assessment_user_group_id=:assessmentGroupId",
        "downloadQuestionnaire": "/benchmark/download",
        "getUsers": "/assessments/users",
        "saveAssessment": "/assessments",
        "saveChoices": "/questionnaire_choices",
        "saveQuestions": "/questionnaire",
        "saveRecommendations": "/recommendations/:assessmentGroupId",
        "selectAnswer": "/select-answer/:assessmentGroupId",
        "submitForReview": "/assessments/:assessmentGroupId/submit",
        "summary": {
            "baseUrl": "/benchmark",
            "getSummary": "?assessment_user_group_id=:assessmentGroupId"
        }
    },
    "scenarioSettings": "/scenario-settings",
    "scenarios": {
        "baseUrl": "/scenarios",
        "details": {
            "baseUrl": "/:id",
            "getOrAddRule": "/scenario-rule",
            "results": {
                "baseUrl": "/results",
                "download": "/download",
                "paginated": "?limit=:limit&offset=:offset"
            },
            "run": "/run",
            "scenarioConfig": {
                "baseUrl": "/scenario-settings",
                "withBuildInScenario": "?build_on_scenario_id=:build_on_scenario_id"
            },
            "scenarioConfigurations": {
                "baseUrl": "/scenario-configurations",
                "details": "/:config_id",
                "download": "/download",
                "upload": "/upload"
            }
        },
        "download": "/download",
        "results": {
            "baseUrl": "/results",
            "download": "/download"
        },
        "upload": "/upload"
    },
    "sku": {
        "baseUrl": "/sku",
        "id": {
            "baseUrl": "/:sku_id",
            "locationId": {
                "appliedScenarioConfigurations": "/applied-scenario-configurations",
                "baseUrl": "/location/:location_id",
                "editOnTheFly": "/edit-on-the-fly",
                "forecast": "/forecast",
                "multipleSimulation": "/multiple-simulation",
                "poData": {
                    "baseUrl": "/po-data",
                    "download": "?type=download"
                },
                "simulation": {
                    "baseUrl": "/simulation",
                    "download": "/:download_type",
                    "projection": "?projection=:projection"
                },
                "verify": "/verify"
            },
            "locations": "/locations"
        },
        "search": "/search"
    },
    "skuLocation": {
        "baseUrl": "/sku-location",
        "count": "/count",
        "details": {
            "appliedScenarioConfiguration": "applied-scenario-configurations",
            "baseUrl": "/:id/",
            "editOnTheFly": "edit-on-the-fly",
            "forecast": {
                "baseUrl": "forecast"
            },
            "multipleSimulation": "multiple-simulation",
            "poData": {
                "baseUrl": "po-data",
                "download": "?type=download"
            },
            "simulation": {
                "baseUrl": "simulation",
                "download": "/download",
                "getSimulations": {
                    "baseUrl": "/"
                }
            }
        },
        "search": "/search"
    },
    "stockScenarioInfo": "stock-scenario-info",
    "storageLocations": {
        "baseUrl": "storage-locations",
        "sku": "/sku/:id"
    },
    "system": {
        "baseUrl": "/system",
        "dataModel": "/data-model",
        "downloadTemplate": "/download-template/:type?file_type=:file_type",
        "exportData": "/export-data",
        "filterData": "/filter-data",
        "pageConfigurations": {
            "baseUrl": "/page-configurations",
            "getById": "?config_id=:config_id",
            "updateOrDelete": "?config_id=:config_id"
        },
        "publishEvent": "/publish-event",
        "tenant": "/tenants"
    },
    "targetOverview": "/target-overview",
    "targetOverviewDetails": "/target-overview-details",
    "timeSeries": {
        "baseUrl": "/time-series",
        "overview": "/overview"
    },
    "transformerConfig": "/transformer_config",
    "translations": "/system/translations/:language/:namespace"
};

/**
 * Replace Params key in url with value
 * @param {string} urlPart - Part of the url
 * @param {object} urlParams - Url params
 * @returns {string} - Url with params key replaced
 */
function replaceParams(urlPart, urlParams) {
    // Replace all url params
    Object.keys(urlParams).forEach((key) => {
        urlPart = urlPart.replace(`:${key}`, urlParams[key]);
    });

    // Check if all params were provided, else return empty string
    const urlParts = urlPart.split(/:[A-Za-z]*\//);
    if (urlParts.length > 1) {
        throw Error("All url params not provided");
    }

    return urlPart;
}

/**
 * Parses the key, fetches url partials and generates url.
 * @param {object} obj - Base object
 * @param {Array} keyArr - Array of keys
 * @param {number} index - Index no
 * @param {object} urlParams - JSON Object of url parameters
 * @returns {string} - API Url with url params
 */
function urlMaker(obj, keyArr, index, urlParams) {
    try {
        if (index === keyArr.length) {
            // If last key is an object, then select baseUrl of the object
            if (typeof obj === "object") {
                obj = obj.baseUrl || "";
            }

            return replaceParams(obj, urlParams);
        }
        const urlPart = replaceParams(obj.baseUrl || "", urlParams);

        return urlPart + urlMaker(obj[keyArr[index]], keyArr, ++index, urlParams);
    } catch (ex) {
        // eslint-disable-next-line no-console
        console.error("Error while generating url - ", ex);
    }

    return null;
}

/**
 * Construct url by replacing url params and adding query params
 * @param {*} apiName - Name of api to get url
 * @param {*} urlParams - (Optional) - List of params
 * @param {*} encode - Whether to encode url params
 * @returns {string} - API Url with url params
 */
export const serviceUrls = (apiName, urlParams = {}, encode = true) => {
    if (urlParams && encode) {
        Object.keys(urlParams).forEach((param) => {
            urlParams[param] = encodeURIComponent(urlParams[param]);
        });
    }

    return urlMaker(apiConstants, apiName.split("."), 0, urlParams);
};
